/**
 * Marcação de dado pessoal, para a auditoria de LEITURA.
 *
 * O protótipo exige em #m-aluno: "Toda leitura desta ficha é registrada
 * em auditoria", e o feed de #v-acessos mostra o resultado —
 * "Camila abriu a ficha de Brenda Loureiro · leitura de dado pessoal".
 *
 * Auditar leitura exige saber QUAIS recursos e campos são dado pessoal.
 * Esse conhecimento vive aqui, e não num módulo de domínio, porque o
 * interceptor que grava a trilha é da camada de acesso.
 *
 * Ver: Arena_backend/Docs/plano/03-access-tres-dimensoes.md
 */
/** Ler qualquer um destes recursos gera linha de auditoria. */
export const RECURSOS_COM_DADO_PESSOAL = new Set([
    'alunos',
    'cobrancas',
    'folha',
    'comanda',
]);
/**
 * Campos que nunca podem aparecer em log, mensagem de erro ou
 * exportação não autorizada. A lista erra por excesso de propósito:
 * é mais barato acrescentar um campo ao log depois do que remover um
 * dado pessoal que já vazou para o arquivo.
 */
export const CAMPOS_SENSIVEIS = [
    'senha',
    'senha_hash',
    'token',
    'refresh_token',
    'segredo_totp',
    'codigos_recuperacao',
    'cpf',
    'telefone',
    'email',
    'nascimento',
    'observacoes_medicas',
    'contato_emergencia_telefone',
    'authorization',
    'cookie',
    // O termo da busca de alunos (documento 08). Pode ser um CPF, um
    // telefone ou um nome — e a trilha é append-only: o que entra nela a
    // anonimização não alcança depois.
    'busca',
];
export function ehDadoPessoal(recurso) {
    return RECURSOS_COM_DADO_PESSOAL.has(recurso);
}
//# sourceMappingURL=dado-pessoal.js.map